import usePrivateAxios from "@/common/api/usePrivateAxios";
import { useMutation } from "@tanstack/react-query";
import { ObjectiveActionsValidationSchema } from "../schemas/objectiveActions.schema";

interface UseUpdateObjectiveActionProps {
  id?: string;
  onSuccess?: () => void
  onError?: (error: any) => void
}

const useUpdateObjectiveAction = ({ id, onSuccess, onError }: UseUpdateObjectiveActionProps) => {
  const privateAxios = usePrivateAxios();

  return useMutation({
    mutationKey: ['updateMaintenanceObjectiveAction', id],
    mutationFn: (data: ObjectiveActionsValidationSchema) => {
      const payload = {
        objective_action: {
          display_name: data.display_name,
          description: data.description,
        }
      }

      return privateAxios.put(`/maintenance/objective_actions/${id}`, payload);
    },
    onSuccess,
    onError,
  });
}

export default useUpdateObjectiveAction;
